import React from 'react';
import { useLocation } from 'react-router-dom';
import { ReferenceRouteFormDto } from '../../../types';
import CustomInput from '../../global-components/customInput';
import SelectProjectDropdown from '../../global-components/SelectProjectDropdown';

interface Props {
  validating?: boolean;
  isVendor?: boolean;
  referenceRouteForm: ReferenceRouteFormDto;
  setReferenceRouteForm: React.Dispatch<
    React.SetStateAction<ReferenceRouteFormDto>
  >;
  isReferenceOneManditory: boolean;
}

export default function ReferenceFields({
  validating,
  isVendor,
  referenceRouteForm,
  setReferenceRouteForm,
  isReferenceOneManditory,
}: Props) {
  const location = useLocation();
  const gatewayNumber = new URLSearchParams(location.search).get('job_id');

  return (
    <div>
      <CustomInput
        id={'reference_one'}
        className='form-control ubbe-input'
        label={'Reference 1'}
        type={'text'}
        required={isVendor || isReferenceOneManditory}
        placeholder={'PO, BOL, FF Numbers, Etc.'}
        error={'Please provide a reference.'}
        validating={validating}
        value={referenceRouteForm?.reference_1}
        maxLength={30}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setReferenceRouteForm({
            ...referenceRouteForm,
            reference_1: e.target.value,
          });
        }}
      />
      <CustomInput
        id={'reference_two'}
        className='form-control ubbe-input'
        label={'Reference 2'}
        type={'text'}
        placeholder={'PO, BOL, FF Numbers, Etc.'}
        value={referenceRouteForm?.reference_2}
        maxLength={30}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setReferenceRouteForm({
            ...referenceRouteForm,
            reference_2: e.target.value,
          });
        }}
      />
      {!gatewayNumber && (
        <div className='mb-3'>
          <div
            className='globalInputLabel'
            style={{ padding: '7px 0' }}
          >
            Project
          </div>
          <SelectProjectDropdown
            selectedProject={referenceRouteForm?.project_name}
            setSelectedProject={(value: any) => {
              setReferenceRouteForm({
                ...referenceRouteForm,
                project_name: value,
              });
            }}
          />
        </div>
      )}
      <CustomInput
        id={'booking_date'}
        className='form-control ubbe-input'
        label={'Booking Date'}
        isDatePicker
        type={'text'}
        placeholder={'Booking Date'}
        value={referenceRouteForm.booking_date}
        minDate={new Date()}
        onChange={(date: any) => {
          setReferenceRouteForm({
            ...referenceRouteForm,
            booking_date: date.toISOString(),
          });
        }}
      />
    </div>
  );
}
